const ACTION_LABELS = {
  ADMIN_USER_CREATED: 'Usuario creado (admin)',
  ADMIN_PLAN_CREATED: 'Plan creado (admin)',
  TEAM_USER_CREATED: 'Usuario de equipo creado',
  TEAM_USER_UPDATED: 'Usuario de equipo actualizado',
  TEAM_USER_DELETED: 'Usuario de equipo eliminado',
  subscription_reactivated: 'Suscripción reactivada',
  subscription_past_due: 'Suscripción en mora',
  subscription_suspended: 'Suscripción suspendida',
  'Crear cliente': 'Cliente creado',
  'Eliminar cliente': 'Cliente eliminado',
  'Editar cliente': 'Cliente editado',
};

export function formatAdminActionLabel(action = '') {
  if (ACTION_LABELS[action]) return ACTION_LABELS[action];
  return String(action)
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());
}

export function adminTimeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Hace un momento';
  if (mins < 60) return `Hace ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `Hace ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `Hace ${days} d`;
  return new Date(dateStr).toLocaleDateString('es-AR');
}

export const ADMIN_ROUTE_LABELS = {
  '/admin/dashboard': 'Inicio',
  '/admin/users': 'Usuarios',
  '/admin/companies': 'Empresas',
  '/admin/plans': 'Planes',
  '/admin/beta': 'Programa beta',
  '/admin/system': 'Sistema',
  '/admin/fiscal': 'Parametría fiscal',
};
